import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse, ProperHttpParamEncoder } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TopicInfoModel } from 'app/generated/backend/content/api/topic-info-model';

@Injectable()
export class TopicInfoHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		uri: string,
		languageIso2: string,
		access: number
	): Observable<JsonResourceResponse<TopicInfoModel>> {
		let params = new HttpParams({ encoder: new ProperHttpParamEncoder() });
		if (uri!==null && uri!==undefined) {
			params = params.set('uri', uri);
		}
		if (languageIso2!==null && languageIso2!==undefined) {
			params = params.set('languageIso2', languageIso2);
		}
		if (access!==null && access!==undefined) {
			params = params.set('access', access.toString());
		}
		return this.http.get<JsonResourceResponse<TopicInfoModel>>('api/content/topic/info', { params }).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		TopicInfoHandlerService
	]
})
export class TopicInfoHandlerModule { }
